import { ref, computed } from 'vue'
import { useUserStore } from '@/store/user'
import useTeamShare from '@teams/common/hooks/useTeamShare'
import { useGroupStore } from '@teams/common/store/group'

export type PageType =
  | 'bannedSpace' // 封禁 k.wps.cn/:groupId
  | 'notFoundSpace' // 空间不存在 k.wps.cn/:groupId
  | 'privateSpace' // 私密空间 k.wps.cn/:groupId
  | 'inviteSpace' // 邀请页 k.wps.cn/:groupId
  | 'inviteNotFoundSpace' // 邀请链接失效页
// | 'limitVisitorSpace' // 限制访客浏览空间 k.wps.cn/:groupId 这种情况不会走到Error页
export function useError() {
  const { settingInfo, inviteInfo } = useTeamShare()
  const userStore = useUserStore()
  const groupStore = useGroupStore()
  const loading = ref(true)

  const isLogin = computed(() => !!userStore.currentAccount?.userid)
  const groupAvatarVisible = computed(() => false)
  const pageType = computed<PageType>(() => {
    let type: PageType = 'notFoundSpace'
    const isGroupNotExists = groupStore.isGroupNotExists
    // 空间不存在
    if (isGroupNotExists) {
      return 'notFoundSpace'
    }

    // 从邀请链接进来的
    const isInvited = groupStore.isFromInviteUrl
    const hasInvitedInfo = inviteInfo.value.result === 'ok'
    // 从邀请链接进来并且拿到邀请信息的私密空间
    if (isInvited && hasInvitedInfo && settingInfo.value.private_group) {
      type = 'inviteSpace'
    }
    // 邀请链接失效
    if (isInvited && !hasInvitedInfo) {
      type = 'inviteNotFoundSpace'
    }
    // 直接访问私密空间
    if (!isInvited && settingInfo.value.private_group) {
      type = 'privateSpace'
    }
    // TODO: 封禁状态判断
    return type
  })
  return {
    pageType,
    loading,
    isLogin,
    groupAvatarVisible
  }
}
